import { customerType } from '@/core/constants'
import cleanSource from '@/helpers/clean-source'

/**
 * Serializes a customer before sending it to the API
 *
 * @param {Object} customerObject
 * @returns {Object}
 */
export function serialize(customerObject) {
  const customer = cleanSource({ ...customerObject })

  if (customer.type === customerType.COMPANY) {
    delete customer.last_name
    delete customer.first_name
  }

  if (customer.type === customerType.PERSON) {
    delete customer.business_id
    delete customer.company_name
    delete customer.vat_number
    delete customer.contact_name
  }

  return customer
}

export default {}
